export const validFileTypes = ['image/png', 'image/jpg', 'image/jpeg', 'video/mp4', 'audio/mpeg', 'audio/wav']

export function formatAsset(asset) {
  if (!asset) return

  if (asset._id) {
    asset.id = asset._id
    delete asset._id
  }

  if (!asset.text) asset.text = ''
  if (!asset.cleanText) asset.cleanText = ''
  if (!asset.annotations) asset.annotations = []
  if (!asset.caption) asset.caption = ''

  return asset
}